import script from "./UiCloseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCloseButton.vue?vue&type=script&setup=true&lang=js"

import "./UiCloseButton.vue?vue&type=style&index=0&id=1b42d152&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b42d152"]])

export default __exports__